import 'babel-polyfill';
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { getStatusCode } from '../../selectors/status';
import {
  getUserLegacySettings,
  getUserId,
} from '../../selectors/user';
import {
  showPrintVersion,
} from '../../selectors/forecast';
import {
  getCMSMenuLocations,
} from '../../selectors/cms';
import legacyUserSettingsPropType from '../../propTypes/legacyUserSettings';
import { fetchMenuLocations } from '../../actions/cms/menuLocations';
import GlobalHeader from '../../components/GlobalHeader';
import GlobalFooter from '../../components/GlobalFooter';
import PageError from '../../components/Errors/PageError';
import NotFound from '../../components/Errors/NotFound';
import {
  clickedSubscribeCTA,
  trackEvent,
} from '../../actions/segmentEvents';
import { getIsPremiumEntitlement } from '../../selectors/entitlements';

class BuoyweatherPageContainer extends Component {
  static rootContainer = true;
  static fetch = [
    () => fetchMenuLocations(),
  ];

  getClassName = () => classNames({
    'bw-page-container': !this.props.printVersion,
    'bw-page-container--fullscreen': this.isFullscreenPage(),
    'bw-page-container--print': this.props.printVersion,
    'bw-page--non-premium-user': !this.props.isPremium,
  });

  fullScreenRoutes = [
    '/map/',
  ];


  pageContent = () => {
    const {
      legacyUserSettings,
    } = this.props;
    if (this.props.status === 404) {
      return <NotFound />;
    } else if (this.props.status === 500) {
      return <PageError legacyUserSettings={legacyUserSettings} />;
    }
    return this.props.children;
  }

  isFullscreenPage() {
    const { pathname } = this.props.router.getCurrentLocation();
    const isHomepage = pathname === '/';

    const isFullSscreenRoute = this.fullScreenRoutes.some((checkPath) => {
      if (pathname === checkPath || pathname.includes(checkPath)) {
        return true;
      }
      return false;
    });
    if (isFullSscreenRoute) {
      return true;
    } else if (isHomepage) {
      return true;
    }

    return false;
  }

  showFooter() {
    const { printVersion } = this.props;

    if (printVersion) {
      return false;
    }

    if (this.isFullscreenPage()) {
      return false;
    }

    return true;
  }

  render() {
    const {
      locations,
      legacyUserSettings,
      doClickedSubscribeCTA,
      doTrackEvent,
      printVersion,
      userId,
    } = this.props;

    return (
      <div className={this.getClassName()}>
        {!printVersion ?
          <GlobalHeader
            locations={locations}
            userId={userId}
            user={legacyUserSettings}
            doClickedSubscribeCTA={doClickedSubscribeCTA}
            doTrackEvent={doTrackEvent}
            isFullscreenPage={this.isFullscreenPage()}
          /> : null}
        <div role="main" id="main">
          {this.pageContent()}
        </div>
        {this.showFooter() ? <GlobalFooter /> : null}
      </div>
    );
  }
}

BuoyweatherPageContainer.propTypes = {
  userId: PropTypes.string,
  printVersion: PropTypes.bool,
  children: PropTypes.node,
  status: PropTypes.number.isRequired,
  legacyUserSettings: legacyUserSettingsPropType.isRequired,
  doClickedSubscribeCTA: PropTypes.func.isRequired,
  doTrackEvent: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  router: PropTypes.object.isRequired,
};

BuoyweatherPageContainer.defaultProps = {
  userId: null,
  children: null,
  printVersion: false,
};

export default connect(
  state => ({
    userId: getUserId(state),
    status: getStatusCode(state),
    locations: getCMSMenuLocations(state),
    legacyUserSettings: getUserLegacySettings(state),
    getUserId,
    printVersion: showPrintVersion(state),
    isPremium: getIsPremiumEntitlement(state),
  }),
  dispatch => ({
    doClickedSubscribeCTA: properties =>
      dispatch(clickedSubscribeCTA(properties)),
    doTrackEvent: (name, properties) =>
      dispatch(trackEvent(name, properties)),
  }),
)(BuoyweatherPageContainer);



// WEBPACK FOOTER //
// ./src/containers/routes/BuoyweatherPageContainer.js